import styled from 'styled-components';

const Textarea = styled.div`
  &.form-item-textarea .form-item-input {
    height: 96px;
    padding: 6px 0 20px 6px;

    textarea {
      border: 0;
      width: 100%;
      height: 100%;
      resize: none;
      line-height: 16px;
    }
  }

  .form-item-counter {
    position: absolute;
    right: 12px;
    bottom: 5px;
    line-height: 1;
  }
`;

export default {
  Textarea,
};
